<template>
    <div>
        <div class="container-butacas-wrapper scroll-smooth mb-2" v-if="!loading" ref="butacasWrapper">
            <div :class="'container-butacas animated fadeInLeft text-align-' + print_align">
                <span v-for="(fila, index_fila) in orderedFilas" :key="index_fila">
                    <span class="fila">{{ fila.alias }}</span>
                    <div class="ml-3">
                        <AsientoComponent
                            v-for="(asiento, index) in fila.asientos"
                            :asiento="asiento"
                            :fila="String(fila.alias)"
                            :front="true"
                            :disabled="!isAsientoSeleccionable(asiento)"
                            :key="index+'_2'"
                            @toggle="() => toggleSeleccion(asiento, fila.alias)"
                        />
                    </div>
                </span>
            </div>
        </div>
        <TerrenoJuegoComponent/>
        <template v-if="loading">
            <LoaderComponent/>
        </template>
    </div>
</template>

<script>
    import TerrenoJuegoComponent from './TerrenoJuegoComponent.vue';
    import AsientoComponent from "@/components/backend/stepper/components/AsientoComponent";

    export default {
        props: {
            loading: {
                type: Boolean,
                required: true
            },
            print_align: {
                type: String,
                required: true
            },
            filas: {
                type: [Array, Object],
                required: true
            }
        },
        computed: {
            orderedFilas() {
                const filas = Array.isArray(this.filas)
                    ? this.filas.slice()
                    : Object.values(this.filas || {});

                return filas.sort((filaA, filaB) => {
                    const aliasA = filaA && filaA.alias != null ? String(filaA.alias) : '';
                    const aliasB = filaB && filaB.alias != null ? String(filaB.alias) : '';

                    return aliasB.localeCompare(aliasA, undefined, {
                        numeric: true,
                        sensitivity: 'base'
                    });
                });
            }
        },
        methods: {
            /**
             * Un asiento es seleccionable sólo si está libre (0).
             *
             * Este mapa lo comparten los flujos Front (venta de abonos y cambio
             * de asiento), donde una butaca bloqueada NO debe seleccionarse: la
             * capacidad de actuar sobre bloqueos es del gestor Admin y se declara
             * ahí con `allowBlocked`. Quedan fuera ocupadas (1/true), pendientes
             * (2), reservadas (`info.reserva_id`) y ocultas.
             *
             * @param {Object} asiento
             * @returns {boolean}
             */
            isAsientoSeleccionable(asiento) {
                if (!asiento) return false;
                if (asiento.oculto && asiento.oculto > 0) return false;
                if (asiento.ocupado === 1 || asiento.ocupado === true) return false;
                if (asiento.ocupado === 2) return false;
                if (asiento.info?.reserva_id) return false;

                return asiento.ocupado === 0 || asiento.ocupado === false;
            },
            /**
             * Emite el asiento seleccionado sin mutar la prop.
             *
             * Antes escribía `asiento.fila = filaAlias` sobre el objeto recibido,
             * que pertenece al padre: un efecto lateral oculto que rompía el flujo
             * unidireccional de datos. Ahora la fila viaja en el payload del evento
             * y cada consumidor decide qué hacer con ella.
             *
             * Se mantiene la referencia original (en lugar de una copia) porque los
             * consumidores ya mutan el asiento que reciben —`seleccionado`,
             * `zona_nombre`— y esperan que el mapa reaccione por reactividad.
             *
             * @param {Object} asiento
             * @param {string|number} filaAlias
             */
            toggleSeleccion(asiento, filaAlias) {
                if (!this.isAsientoSeleccionable(asiento)) {
                    return;
                }
                this.$emit('asientoSeleccionado', asiento, filaAlias);
            }
        },
        components: {
            TerrenoJuegoComponent, AsientoComponent
        }
    }
</script>
